<template lang="pug">
multiselect#WtMultiSelectDropDown(
  v-model="internalValue"
  :options="options"
  :multiple="true"
  :close-on-select="closeOnSelect"
  :preserve-search="preserveSearch"
  :placeholder="placeholder"
  :label="label"
  :track-by="trackBy"
  :preselect-first="preselectFirst"
  :open-direction="openDirection"
  :hide-selected="hideSelected"
  :show-no-options="true"
  :show-no-results="true"
  :option-height="100"
  :options-limit = "optionsLimit"
  :internal-search="!asyncSearch"
  :loading="loading"
  @input="handleSelectUnselect"
  @search-change="handleSearch"
)
  template(slot="selection" slot-scope="{ values, search, isOpen }")
    span.multiselect__single(v-if="values.length" v-show="!isOpen")
      | {{ values.length }} options selected
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect
  },
  props: {
    options: {
      type: Array,
      default: null
    },
    closeOnSelect: {
      type: Boolean,
      default: false
    },
    clearOnSelect: {
      type: Boolean,
      default: true
    },
    preserveSearch: {
      type: Boolean,
      default: null
    },
    placeholder: {
      type: String,
      default: "Select one"
    },
    label: {
      type: String,
      default: "name"
    },
    trackBy: {
      type: String,
      default: "name"
    },
    preselectFirst: {
      type: Boolean,
      default: true
    },
    openDirection: {
      type: String,
      default: "bottom"
    },
    hideSelected: {
      type: Boolean,
      default: true
    },
    optionsLimit: {
      type: Number,
      default: 30
    },
    value: {
      type: Array,
      default: null
    },
    asyncSearch: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      internalValue: null
    };
  },
  watch: {
    options: {
      immediate: true,
      handler() {
        if (!this.value) {
          this.internalValue = null;
        }
      }
    },
    value: {
      immediate: true,
      handler(newVal) {
        // Sync external value prop to internal state
        this.internalValue = newVal || null;
      }
    }
  },
  methods: {
    handleSelectUnselect(value) {
      this.$emit("selectUnselect", value);
    },
    handleSearch(query) {
      if (this.asyncSearch) {
        this.$emit("search", query);
      }
    }
  }
};
</script>

<style lang="sass" scoped>
@import '../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css';
</style>
